import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { UserService } from '@app/core';
import {ModelOption} from "@app/solution-manager/system/model-options/model-options";


@Injectable()
export class ModelOptionService {


  constructor (private http: HttpClient, private user: UserService) { }

  getModelOptionById(modelOptionId): Observable<ModelOption> {
    const url = `/solution/coa-model/options/${modelOptionId}`;
    return this.http.get<ModelOption>(url);
  }

  saveModelOption(modelOption): Observable<any> {
    const url = `/solution/coa-model/options/`;
    return this.http.post(url, modelOption);
  }

  updateModelOption(modelOption): Observable<any> {
    const url = '/solution/coa-model/options/' + modelOption.id;
    return this.http.put(url, modelOption);
  }

  mapAccountsToModelOption(modelOptionId): Observable<any> {
    console.log(this.user);
    const url = `/solution/model-option/map-universal-accounts?orgId=${this.user.managingOrgId}&modelOptionId=${modelOptionId}`;
    return this.http.get(url);
  }



}
